import { render, staticRenderFns } from "./CourseSchedules.vue?vue&type=template&id=08ac6ac7"
import script from "./CourseSchedules.vue?vue&type=script&lang=js"
export * from "./CourseSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports